export const PAYMENT_SETTINGS = {
  payAtEndOfMonth: 'payAtEndOfMonth',
  pad: 'pad',
  nettCod: 'nettCod',
  topupCredit: 'topupCredit'
} as const
